<template>
<div class="jfdetail">
	<div class="van-nav-bar van-hairline--bottom custom-nav-bar">
		<div class="van-nav-bar__content">
			<div class="van-nav-bar__left van-haptics-feedback" @click="back()">
				<i class="van-badge__wrapper van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
			</div>
			<div class="van-nav-bar__title van-ellipsis">
				{{$t('moneylog.title')}}
			</div>
		</div>
	</div>
	<van-pull-refresh v-model="isLoading" class="fixedStyle"  @refresh="onRefresh">
	  <van-list
	      v-model="loading"
	      :finished="finished"
	      :immediate-check="false"
	      :finished-text="$t('common.nomore')"
	      @load="onLoad">
		  <div class="list-container">
			  <van-cell-group class="custom-cell-group">
			    <van-cell v-for="(item,i) in tableList" :key="i" class="custom-cell">
					<template #title>
						<div class="box">
							<div class="left">
								$
							</div>
							<div class="content">
								<p class="type-text">
									{{typeExt[item.type]}}
								</p>
								<span class="time-text">
									{{item.createtime}}
								</span>
							</div>
						</div>
						<span class="memo-text" v-if="item.type!=1 && item.type!=5">
							({{item.memo}})
						</span>
						<span class="memo-text" v-if="item.type==1">
							{{$t('moneylog.rechargeNote')}}
						</span>
					</template>
					<template #default>
						<span class="amount-positive" v-if="item.money>=0">
							+{{item.money}}
						</span>
						<span class="amount-negative" v-else>
							{{item.money}}
						</span>
					</template>
				</van-cell>
			  </van-cell-group>
		  </div>
	  </van-list>
	  <van-empty :description="$t('common.nodata')" v-if="tableList.length === 0"/>
	</van-pull-refresh>
</div>
</template>

<script>
import { Toast } from 'vant';
export default {
  data () {
    return {
      page:1,
      isLoading: false,
      count:0,
	  limit:10,
      loading: false,
      finished: false,
      refreshing: false,
      tableList:[],
	  typeExt:['0',this.$t('moneylog.type1'),this.$t('moneylog.type2'),this.$t('moneylog.type3'),this.$t('moneylog.type4'),this.$t('moneylog.type5'),this.$t('moneylog.type6')],
    }
  },
  mounted () {
    this.getPinglunList()
    window.addEventListener("scroll", this.scrollTops, true);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollTops);
  },
  methods: {
	  back(){
	    return window.history.back();
	  },
	quickList(id){
	  if(!localStorage.getItem('token')){
	    this.$router.push({path:'/Login'})
	  }else {
	    this.$router.push({path:'/PinglunDetail?id='+id})
	  }
	
	},
    longPress() {
      document.querySelector('.fixedStyle').scrollTop = 0
    },
    scrollTops(){
      this.scrollTop1 = document.querySelector('.fixedStyle').scrollTop
    },

    getPinglunList(){
        this.$http({
          method: 'get',
          data:{page: this.page,limit: this.limit},
          url: 'money_log'
        }).then(res=>{
			console.log(res);
          this.tableList  = this.tableList.concat(res.data.data);
          this.count = res.data.total;
          this.page++;      
        })
    },
    onRefresh(){
      setTimeout(() => {
        this.finished = false;
        this.loading = true;
        this.onLoad();
        this.isLoading = false;
        Toast(this.$t('common.refresh'));
      }, 500);
    },
    onLoad() {
      //初始化列表
      this.getPinglunList()
	  let timer = setTimeout(() => {
	    if (this.refreshing) {
	      this.tableList = [];
	      this.refreshing = false;
	    }
	    this.loading = false;
	    if (this.tableList.length === this.count) {
	      this.finished = true;
	    }
	    this.finished && clearTimeout(timer);//清除计时器
	  }, 500);
    },
  },
}
</script>

<style scoped>
:export {
    gbcolor: linear-gradient(135deg, #3498db, #8e44ad)
}

.jfdetail {
    width: 100%;
    min-height: 100vh;
    background: white;
}

/* 顶部导航栏样式 - 填充渐变色 */
.custom-nav-bar {
    height: 3.5rem;
    line-height: 3.5rem;
    background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
    position: relative;
    z-index: 10;
}

.custom-nav-bar::after {
    display: none;
}

.van-nav-bar__title {
    max-width: 60%;
    margin: 0 auto;
    color: white !important;
    font-weight: 600;
    font-size: 1.1rem;
}

.van-nav-bar__left {
    padding: 0 15px;
}

.van-nav-bar__arrow {
    color: white !important;
    font-size: 1.2rem;
    font-weight: bold;
}

/* 内容区域样式 */
.fixedStyle {
    background: white;
    min-height: calc(100vh - 3.5rem);
}

.list-container {
    padding: 1rem;
}

/* 自定义单元格组 */
.custom-cell-group {
    background: transparent;
    border: none;
}

.custom-cell-group::after,
.custom-cell-group::before {
    display: none;
}

/* 每个栏目带边框 */
.custom-cell {
    margin-bottom: 0.8rem;
    border: 1.5px solid #e8e8e8;
    border-radius: 12px;
    padding: 1rem;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
}

.custom-cell:active {
    background-color: #f8f9ff;
    border-color: #667eea;
    transform: translateY(1px);
}

.custom-cell::after {
    display: none;
}

/* 内容布局 */
.box {
    display: flex;
    align-items: flex-start;
    margin-bottom: 0.5rem;
}

.left {
    width: 2.8rem;
    height: 2.8rem;
    background: linear-gradient(135deg, #3498db, #8e44ad);
    margin-right: 12px;
    border-radius: 50%;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.3rem;
    font-weight: 600;
    flex-shrink: 0;
}

.content {
    flex: 1;
}

.type-text {
    font-weight: 600;
    color: #333;
    font-size: 1rem;
    margin-bottom: 0.3rem;
}

.time-text {
    font-size: 0.75rem;
    color: #888;
}

.memo-text {
    color: #969799 !important;
    font-size: 0.8rem;
    line-height: 1.2;
}

/* 金额样式 */
.amount-positive {
    color: #3cd197 !important;
    font-size: 1.1rem;
    font-weight: 600;
}

.amount-negative {
    color: #f56969 !important;
    font-size: 1.1rem;
    font-weight: 600;
}

/* 列表加载状态样式 */
.van-list__error-text, 
.van-list__finished-text, 
.van-list__loading {
    color: #969799;
    font-size: 0.9rem;
    line-height: 1.5rem;
    text-align: center;
    padding: 1rem 0;
}

/* 空状态样式 */
.van-empty {
    padding: 3rem 1rem;
}

/* 响应式调整 */
@media (max-width: 320px) {
    .list-container {
        padding: 0.8rem;
    }
    
    .custom-cell {
        padding: 0.8rem;
        margin-bottom: 0.6rem;
    }
    
    .left {
        width: 2.5rem;
        height: 2.5rem;
        font-size: 1.1rem;
    }
}

/* 动画效果 */
@keyframes fadeInUp {
    from { 
        opacity: 0; 
        transform: translateY(15px); 
    }
    to { 
        opacity: 1; 
        transform: translateY(0); 
    }
}

.custom-cell {
    animation: fadeInUp 0.4s ease forwards;
}

.custom-cell:nth-child(odd) {
    animation-delay: 0.1s;
}

.custom-cell:nth-child(even) {
    animation-delay: 0.2s;
}
</style>